import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SidebarItemLayout = ({ icon, link, title, onClick }) => {
    return (
        <div className="group sidebar-item-container">
            <Link
                to={link}
                className="sidebar-item"
                onClick={onClick}
            >
                <FontAwesomeIcon icon={icon} size="2x" />
            </Link>
            {/* Tooltip */}
            <div className="sidebar-tooltip">
                {title}
                <div className="sidebar-tooltip-arrow" />
            </div>
        </div>
    );
};

export default SidebarItemLayout;
